var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 63,
    viewBox: "0 0 125 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.92857C10.5476 2.69048 17.0952 2.69048 23.6429 7.92857C30.1905 13.1667 36.7381 13.1667 43.2857 7.92857C49.8333 2.69048 56.3809 2.69048 62.9286 7.92857C69.4762 13.1667 76.0238 13.1667 82.5714 7.92857C89.119 2.69048 95.6667 2.69048 102.214 7.92857C108.762 13.1667 115.31 13.1667 121.857 7.92857",
    stroke: "#FF5800",
    strokeWidth: 6.28571,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 31.5C10.5476 26.2619 17.0952 26.2619 23.6429 31.5C30.1905 36.7381 36.7381 36.7381 43.2857 31.5C49.8333 26.2619 56.3809 26.2619 62.9286 31.5C69.4762 36.7381 76.0238 36.7381 82.5714 31.5C89.119 26.2619 95.6667 26.2619 102.214 31.5C108.762 36.7381 115.31 36.7381 121.857 31.5",
    stroke: "#FF5800",
    strokeWidth: 6.28571,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 55.0715C10.5476 49.8334 17.0952 49.8334 23.6429 55.0715C30.1905 60.3096 36.7381 60.3096 43.2857 55.0715C49.8333 49.8334 56.3809 49.8334 62.9286 55.0715C69.4762 60.3096 76.0238 60.3096 82.5714 55.0715C89.119 49.8334 95.6667 49.8334 102.214 55.0715C108.762 60.3096 115.31 60.3096 121.857 55.0715",
    stroke: "#FF5800",
    strokeWidth: 6.28571,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.02b530fe7509d12413d1faa2f1c1dcbd.svg";
export { ForwardRef as ReactComponent };